// extracted by mini-css-extract-plugin
module.exports = {"flex":"Showcase_flex__3VnNj","showcase":"Showcase_showcase__1tr_F","media":"Showcase_media__1pACc"};